import React, { useEffect, useRef } from "react";
import {
  TouchableOpacity,
  Animated,
  StyleSheet,
  Text,
  View,
} from "react-native";
import { AppTheme } from "../../utils/theme";
import DeviceInfo from "react-native-device-info";
const isTablet = DeviceInfo.isTablet();

interface Props {
  value: boolean;
  onChange: (value: boolean) => void;
}

const CustomSwitch: React.FC<Props> = ({ value, onChange }) => {
  const anim = useRef(new Animated.Value(value ? 1 : 0)).current;

  useEffect(() => {
    Animated.timing(anim, {
      toValue: value ? 1 : 0,
      duration: 250,
      useNativeDriver: false,
    }).start();
  }, [value]);

  // Track background animation (Green / Blue)
  const bgColor = anim.interpolate({
    inputRange: [0, 1],
    outputRange: ["#5B4FEA", "#4CAF50"], // OFF = blue, ON = green
  });

  // Thumb/white bubble position
  const translateX = anim.interpolate({
    inputRange: [0, 1],
    outputRange: [0, 50], // Perfect movement
  });

  return (
    <TouchableOpacity
      activeOpacity={0.9}
      onPress={() => onChange(!value)}
      style={{}}
    >
      <Animated.View
        style={[
          styles.container,
          {
            backgroundColor: bgColor,
            borderColor: !value
              ? AppTheme.colors.blueBorder
              : AppTheme.colors.greenBorder,
          },
        ]}
      >
        {/* ON text */}
        {value && (
          <View style={styles.textContainer}>
            <Text style={[styles.onText]}>ON</Text>
          </View>
        )}

        {/* OFF text */}
        {!value && (
          <View style={styles.textContainer}>
            <Text style={styles.offText}>OFF</Text>
          </View>
        )}

        {/* Bubble thumb */}
        <Animated.View
          style={[
            styles.thumb,
            {
              backgroundColor: !value
                ? AppTheme.colors.linearGradient_3
                : AppTheme.colors.green,
              borderColor: !value
                ? AppTheme.colors.blueBorder
                : AppTheme.colors.greenBorder,
              marginTop: -5,
              marginLeft: -5,
              transform: [{ translateX }],
            },
          ]}
        />
      </Animated.View>
    </TouchableOpacity>
  );
};

export default CustomSwitch;

const styles = StyleSheet.create({
  container: {
    width: isTablet ? 78 :75,
    height: isTablet ? 32 : 29,
    borderRadius: 10,
    borderWidth: 2,
    flexDirection: "row",
    alignItems: "center",
  },

  textContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },

  onText: {
    color: AppTheme.colors.white,
    fontFamily: AppTheme.fonts.BUBBLE_BOBBLE,
    fontSize: 20,
    marginRight: 20,
  },

  offText: {
    color: AppTheme.colors.white,
    fontFamily: AppTheme.fonts.BUBBLE_BOBBLE,
    fontSize: 20,
    textAlign: "right",
    marginLeft: 20,
  },

  thumb: {
    width: isTablet ? 35 :33,
    height:isTablet ? 38 : 33,

    borderRadius: 10,
    borderWidth: 2,
    position: "absolute",
    top: 0,
    left: 0,
  },
});
